import React from 'react'
import { colors } from '../../consts'
import { AccordionParams } from './accordion.types'
import { AccordionCon } from './styles'
import { ExpandMoreIcon } from '../../LazyComponents/lazyIcons'
import { Accordion, AccordionDetails, AccordionSummary } from '../../LazyComponents/Accordions/Accordion'

export const BasicAccordion: React.FC<AccordionParams> = ({
  defaultPanel,
  accordionItems,
}) => {
  const [expanded, setExpanded] = React.useState<string | false>(`panel${defaultPanel}`)

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false)
    }

  return (
    <AccordionCon>
      {accordionItems.map((acc, idx) => (
        <Accordion
          key={idx}
          disableGutters
          sx={{
            boxShadow: 'none',
            border: 'none',
            backgroundColor:
              acc.colorTheme === 'dark'
                ? colors.darkBackground
                : acc.colorTheme === 'darkGray'
                ? colors.gray.gray75
                : acc.colorTheme === 'gray'
                ? colors.gray.gray20
                : colors.white,
            borderRadius: 2,
            marginTop: {
              xs: 1,
              sm: 1,
              md: 1,
              lg: 1,
            },
            marginBottom: {
              xs: 0,
              sm: 0,
              md: 1,
              lg: 1,
            },
          }}
          expanded={expanded === `panel${idx + 1}`}
          onChange={handleChange(`panel${idx + 1}`)}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                fontSize="large"
                sx={{
                  color:
                    acc.colorTheme === 'dark'
                      ? colors.white
                      : acc.colorTheme === 'darkGray'
                      ? colors.gray.gray20
                      : acc.colorTheme === 'gray'
                      ? colors.gray.gray80
                      : colors.gray.gray75,
                }}
              />
            }
            aria-controls={`panel${idx + 1}bh-content`}
            id={`panel${idx + 1}bh-header`}
          >
            <>{acc.headerComponent}</>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              borderRadius: 3,
              border: 'none',
              backgroundColor:
                acc.colorTheme === 'dark'
                  ? colors.darkBackground
                  : acc.colorTheme === 'darkGray'
                  ? colors.gray.gray75
                  : acc.colorTheme === 'gray'
                  ? colors.gray.gray20
                  : colors.white,
              margin: 2,
            }}
          >
            <>{acc.summaryComponent}</>
          </AccordionDetails>
        </Accordion>
      ))}
    </AccordionCon>
  )
}
